/* CONSTANTS */
import { paths } from '@/enums/constants';
import {
  ambassador,
  browserExtension,
  campaigns,
  candidate,
  competencyFrameworkGroup,
  help,
  integrations,
  logout,
  mobility,
  networkMenu,
  predictiveModels,
  recruitmentMenu,
  settings,
  talentMenu,
  teamAnalysis
} from '@/helpers/navigationItems';
/* STORES */
import { useAuthStore } from '@/stores/auth';
import { useGlobalStore } from '@/stores/global';
import { useLocaleStore } from '@/stores/locales';
import type { NavItemType } from '@/types/navigation/navigation.types';
/**
 * Each menu will be referenced here
 */
const network = {
  ...networkMenu
};

const recruitment = {
  ...recruitmentMenu,
  items: [campaigns, predictiveModels]
};

const talent = {
  ...talentMenu,
  items: [teamAnalysis, mobility, competencyFrameworkGroup]
};

const menuTypes = {
  userMenu: [candidate, settings, ambassador, integrations, browserExtension, help, logout],
  navMenu: [network, recruitment, talent],
  mobileNavMenu: [network, recruitment]
};

/**
 * Check permission for a specified menu, and return it
 *
 * @param {String} type : menu type
 * @returns {Array<Object>} An array containing all availables options
 */
export function getMenu(type: string): NavItemType[] {
  // Check main items permissions
  const menu = menuTypes[type].filter(menuItem => {
    if (menuItem.isVisible && !menuItem.isVisible()) {
      return false;
    }
    if (menuItem.permissions) {
      return useAuthStore().hasPermissionsList(menuItem.permissions);
    } else {
      return true;
    }
  });
  // Check sub items permissions
  menu.forEach(menuItem => {
    if (menuItem.items) {
      menuItem.items = menuItem.items.filter(subItem => {
        if (subItem.isVisible && !subItem.isVisible()) {
          return false;
        }
        if (subItem.permissions) {
          return useAuthStore().hasPermissionsList(subItem.permissions);
        }
        return true;
      });
    }
  });
  // Return menu items only if they were solo items (no subitems) or if they have subitems and there is at least one of them
  return menu.filter(item => !item.items || (item.items && item.items.length));
}

/**
 * Will check if an external redirection is necessary
 *
 * @param {NavItemType} item - navigation objet
 */
export function checkExternalRedirect(item: NavItemType) {
  if (!item.route && item.externalRedirection) {
    const { type, route, handleLanguage } = item.externalRedirection;
    let link = '';
    if (type !== 'link') {
      link = useGlobalStore().getURL(type);
    }
    if (route) {
      let path = paths[type][route];
      // if the route includes several languages, , it will be split into several object properties with the language flag as key - use the current language flag or english one if not existing
      if (handleLanguage) {
        const language = useLocaleStore().getCurrentLang;
        path = path[language] ? path[language] : path['en'];
      }
      link += path;
    }

    if (link) {
      // If need the modal redirection then return the link and do not redirect
      if (item.externalRedirection.modalRedirection) {
        return link;
      } else {
        window.location.assign(link);
      }
    }
  }
}

/* ROUTING GASTON */

/**
 * Redirect to competency framework on gaston
 */
export function redirectToGastonCompetencyFramework(uuid: string | null = null) {
  const type = 'gaston_url';
  const route = 'CFGroup';
  let path = getGastonURL(paths[type][route]);
  if (uuid) {
    path += `?uuid=${uuid}`;
  }
  return window.location.assign(path);
}

/**
 * Generation gaston URL
 * @param {string} path
 * @returns The url
 */
export function getGastonURL(path) {
  return `${useGlobalStore().getURL('gaston_url')}${path}`;
}
